<template>
	<modal ref="modal">
		<template #title>{{action.toUpperCase()}} SMS MESSAGE</template>
		<template #body>
			
					<div class="form-group mb-4">
						<div class="mb-2">SUBSCRIPTION
							|
							<div class="form-check form-check-inline ms-1">
								<input
									v-model="form.subscription[0]"
									id="0"
									name="0"
									class="form-check-input"
									type="checkbox"
									true-value="ALL"
									false-value=""
									@change="checkSubs('ALL')"
								/>
								<label class="form-check-label bg-alt-primary" for="0">ALL</label>
							</div>
						</div>

						<label v-for="(subs,t_index) in subscriptions" class="mb-2">
                            <label class="me-3">
                                <input type="checkbox" @change="checkSubs(subs.subscription)" v-model="form.subscription[t_index+1]" :id="subs.counter" :name="subs.counter" :true-value="subs.subscription" false-value="" />
                                <i class="ms-1"></i><label :for="subs.counter">{{subs.subscription}}</label>
                            </label>
                        </label>

					</div>
					<!-- <div class="form-floating mb-4">
						<select v-model="form.subscription" class="form-control">
							<option value="ALL">ALL</option>
							<option v-for="(row) in subscriptions" :value="row.subscription">{{row.subscription}}</option>
						</select>
						<label class="form-label" for="subscription">Subscription</label>
					</div> -->
					<div class="form-floating mb-4">
						<select v-model="form.day_num" id="day_num" name="day_num" class="form-control">
							<option v-for="num in 180" :value="num">{{num}}</option>
						</select>
						<label class="form-label" for="day_num">Day Number</label>
					</div>
					<div class="form-floating mb-4">
						<textarea v-model="form.sms_message" id="sms_message" class="form-control" placeholder="Enter Message" maxlength="320" style="height:150px;"></textarea>
						<label class="form-label" for="sms_message">Message</label>
						<div class="text-danger">Max Length: {{remain_char}}/{{sms_msg_len}}</div>
					</div>
					<div class="form-group mb-4">
						<label class="form-label" for="is_active">Active</label>
						<div class="mt-2">
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_yes"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="1"
								/>
								<label class="form-check-label bg-alt-primary" for="is_active_on">YES</label>
							</div>
							<div class="form-check form-check-inline">
								<input
									v-model="form.is_active"
									id="is_active_no"
									name="is_active"
									class="form-check-input"
									type="radio"
									value="0"
								/>
								<label class="form-check-label bg-alt-primary" for="is_active_off">NO</label>
							</div>
						</div>
					</div>
				
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span></span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'

export default {
	props: {
		subscriptions : Object
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {
			modal.value.toggleModal()
		}

		const sms_msg_len 		= ref(320);

		const remain_char 		= ref(sms_msg_len.value);
		
		const action 			= ref('add');

		const form = useForm({
						sms_uuid 		: 0,
						subscription 	: [],
						old_subscription: "",
						day_num 		: 1,
						old_day_num 	: 1,
						sms_message 	: '[fname],\n\n',
						is_active 		: 1
					})

		const checkSubs = (stat)=>{
			if(stat=='ALL')
			{
				if(form.subscription[0]=='ALL')
				{
					form.subscription 		= [];
					form.subscription[0] 	= stat;
				}
			}else
			{
				if(form.subscription[0]=='ALL')
				{
					form.subscription[0] = "";	
				}
			}
		}

		const actionContent = ()=>{

			if(action.value=='add')
			{
				addContent();
			}else
			{
				updateContent();	
			}

		}

		const addContent = () => {
			form.post(route('admin.post.sms-message'), {
				preserveState: true,
				preserveScroll: true,
				only:['messages,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.put('sms-message/'+form.sms_uuid, {
				preserveState: true,
				preserveScroll: true,
				only:['messages,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setMessage = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									var subscription 	= data.subscription;

									form.sms_uuid 		= data.sms_uuid;
									form.day_num		= data.day_num;
									form.old_day_num	= data.day_num;
									form.sms_message 	= data.sms_message;
									form.is_active 		= data.is_active;

									form.old_subscription	= subscription;

									form.subscription[0] = "";
									if(subscription=="ALL")
									{
										form.subscription[0] = subscription;
									}else
									{
										var subs_arr =  subscription.split("|");
										for (var i = 0; i < props.subscriptions.length; i++) {
											var subs = props.subscriptions[i].subscription;
											if(subs_arr.includes(subs))
											{
												form.subscription[i+1] = subs;
											}else
											{
												form.subscription[i+1] = "";
											}
										}
									}
								}
								
							}

		watch(()=>form.sms_message,(value)=>{
			if(value!=null)
			{
				remain_char.value = sms_msg_len.value - value.length;		
			}
		})

		return {
			sms_msg_len,
			remain_char,
			form,
			checkSubs,
			modal,
			toggleModal,
			action,
			setMessage,
			actionContent,
			addContent,
			updateContent,
		}
	},
}
</script>
